import { AbstractIcon } from "./abstract";
import { componentsRegistryService } from "cruzo";

/** IBM Carbon Design System — book icon (32px artboard). */
export class CarbonBookIcon extends AbstractIcon {
  static selector = "carbon-book-icon";

  getHTML() {
    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" aria-hidden="true">
      <rect x="19" y="10" width="7" height="2"/>
      <rect x="19" y="15" width="7" height="2"/>
      <rect x="19" y="20" width="7" height="2"/>
      <rect x="6" y="10" width="7" height="2"/>
      <rect x="6" y="15" width="7" height="2"/>
      <rect x="6" y="20" width="7" height="2"/>
      <path d="M28,5H4A2.002,2.002,0,0,0,2,7V25a2.002,2.002,0,0,0,2,2H28a2.002,2.002,0,0,0,2-2V7A2.002,2.002,0,0,0,28,5ZM4,7H15V25H4ZM17,25V7H28V25Z"/>
    </svg>`;
  }
}

componentsRegistryService.define(CarbonBookIcon);
